import $ from 'jquery';

const CAPTCHA_ELEMENT_ID_LIST = [
    'signin-captcha',
    'signup-captcha',
    'signup-captcha-2'
];

const SITE_KEY = '6LcS1NwUAAAAAPjNFRLaWrMfOHH5gUsSWiXkZ8PH';

export const initReCaptcha = () => {
    CAPTCHA_ELEMENT_ID_LIST.forEach(id => {
        const captchaWidgetId = grecaptcha.render(id, {'sitekey': SITE_KEY});

        $(`#${id}`).next('a').attr('data-recaptcha-id', captchaWidgetId);
    });
};

export const getReCaptchaToken = (element) => {
    return grecaptcha.getResponse(element.data('recaptcha-id'));
};

